<form [formGroup]="addPoolConsumptionSearch">
    <!-- {{addPoolConsumptionSearch.value| json}} -->
    <div style="display: flex; width: max-content; ">
        <label style="height: 23px;
    position: relative;
    top: 8px;
    margin-right: 0px;">Days to check*</label>
     <vue-image-tooltip  imageSrc="/assets/icons/icon-exclamation.svg"
          content="{{ 'tooltip.message.underutilization.daystocheck' | translate | async }}"></vue-image-tooltip>
        <div class="box">Next*</div>
        <mat-form-field appearance="outline" class="depo">
            <input formControlName="next" matInput type="text"  (keypress)="onlyNumberKey($event)" placeholder=""  >
        </mat-form-field>
        <span style="height: 22px;
    position: relative;
    top: 3px;
    margin: 10px;">---</span>

        <mat-form-field appearance="outline" class="depo">
            <input formControlName="day" matInput type="text"  (keypress)="onlyNumberKey($event)" placeholder="" >
           
        </mat-form-field>
        <div class="box_right">Days*</div>

    </div>
     <span class="error"  *ngIf="addPoolConsumptionSearch.errors?.invalidRange" style="font-size: small;">
   Second day value must be greater than or equal to First day value.
     </span>
    
    <div  *ngIf="!addPoolConsumptionSearch.errors?.invalidRange" style="    color: #808080b8;
    width: fit-content;
    margin-left: 140px;
    margin-top: -3px;
    margin-bottom: 11px; ">
      <span *ngIf="addPoolConsumptionSearch.get('next')?.valid">Date range: {{this.futuredate}} ---  {{this.currentdate}}</span>  
    </div>
    <div style=" align-items: baseline; margin-top: 10px;">
      
        <mat-radio-group aria-label="Select an option" formControlName="optionControl" (change)="selecteddata($event)">
            <div style="display: flex; width: max-content;">
            <div class="revo">
                  <label style="position: relative; top: -10px; width: min-content;">
            Time configuration*
        </label>
            <mat-radio-button value="0" style="margin-right: 10px;">Per day</mat-radio-button>
            </div>
            <div style="width: fit-content;">
            <div formArrayName="startTime" *ngFor="let data of FormDatasearchData.controls; let i=index">
                <div [formGroupName]="i">
                    <div class="outer-flex-container">
                        <div class="inner-flex-container">
                            <vue-select class="select_width"
                                class="depo"
                                label="{{ 'label.placeholder.startTime' | translate | async }}"
                                formControlName="startTime" [required]="true" [options]="utcStartTimes"
                                [getOptionDisplay]="addUTCToTime.bind(this)"
                                [errorMatcher]="suppressErrorState"></vue-select>
                            <vue-select class="depo"
                                label="{{ 'label.placeholder.endTime' | translate | async }}" formControlName="endTime"
                                [options]="utcEndTimes" [getOptionDisplay]="addUTCToTime.bind(this)" [required]="true"
                                [errorMatcher]="suppressErrorState"></vue-select>
                        </div>
                        <span *ngIf="i!= 0" class="crossButton" (click)="removedatafromSearchPool(i)">&cross;</span>
                    </div>
                    <span class="error" *ngIf=" getValidationcontrols(i).controls['endTime'].errors && (getValidationcontrols(i).controls['endTime'].touched
        && getValidationcontrols(i).controls['endTime'].dirty)"><small>{{'message.warning' | translate |
                            async}}</small> </span>
                </div>
            </div>
            
</div>
 <span style="align-content: center;
    height: 63px;">
               <button  [disabled]="isformDirty()" *ngIf="addtime" style=" margin-left: -9px;
    font-size: 25px;
    color: rgb(40, 180, 244);
    cursor: pointer;
    width: 10px;
    border: none;     background: none;"(click)="Duplicatethedata()"><mat-icon style="  font-size: large;  margin-left: -12px;">add</mat-icon></button>
            </span> 
</div>
           
            <div style="    width: 322px; position: relative; left: 209px; margin-top: -12px;">
                <mat-checkbox formControlName="allday" (change)="checkstatusallday($event)" >All Day</mat-checkbox><br>
                <small *ngIf=" this.addPoolConsumptionSearch.get('optionControl')?.value != 1"  style="    position: relative;
    left: 11px;
    color: grey;
    font-family: sans-serif;">Checks utilization for the selected time range seprately for each date in the date range.</small>
            </div>
            <div style="    
  
    width: 300px;
    position: relative;
    left: 106px;
    margin-top: -3px;
    ">

                <mat-radio-button value="1">Consecutive hourly interval</mat-radio-button>
                <br>

                <vue-select class="depo" style=" position: relative;
    left: 43px;" formControlName="Consecutive" label="Select interval(e.g, 2 hours)"
     [required]="true"
     [options]="conscutive"></vue-select>

     <div *ngIf=" this.addPoolConsumptionSearch.get('Consecutive')?.value == 'Custom'"
     style="margin-top: -23px;
    margin-bottom: 37px;
    margin-left: 43px;
    display: flex;
    align-items: baseline;">
        <label>
            Hours
        </label>
         <vue-image-tooltip style="position: relative; top:14px;" imageSrc="/assets/icons/icon-exclamation.svg"
          content="{{ 'tooltip.message.underutilization.hours' | translate | async }}"></vue-image-tooltip>
        <mat-form-field appearance="outline" style="width: 70px;" class="depo">
            <input formControlName="hours" matInput type="text" placeholder="">
        </mat-form-field>
    </div >
    <div  class="error" style="position: relative;
   top: -18px;
    left: 112px;
    width: fit-content;
    font-size: small;
    font-family: sans-serif;" *ngIf="addPoolConsumptionSearch.get('hours')?.hasError('pattern')">
  Enter a numeric value between 1 and 23.
    </div> 
     <small *ngIf=" this.addPoolConsumptionSearch.get('optionControl')?.value == 1" style="    position: relative;
    left: 41px;
    color: grey;
    top:-24px;
    font-family: sans-serif;">Checks utilization for rolling hourly windows of the  selected duration for each day in the date range.</small>

            </div>
        </mat-radio-group>


    </div>


    <div style="position: relative;
    top: -13px;
">
        <label>
            If Capacity utilization is below*
        </label>
        <mat-form-field appearance="outline" class="depo">
            <input formControlName="percentage" matInput type="text" placeholder=""  >
            <span matTextSuffix>%</span>
                  
        </mat-form-field>
        
    </div>
    <div  class="error" style="position: relative;
    top: 8px;
    left: 149px;
    width: fit-content;
    font-size: small;
    font-family: sans-serif;" *ngIf="addPoolConsumptionSearch.get('percentage')?.hasError('pattern')">
  Enter a numeric value between 1 and 100%.
    </div>  
</form>